"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors; // eslint-disable-next-line react/prop-types

var CrossSvg = function CrossSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    viewBox: "0 0 14 14",
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: colors.legacy[color] || color,
    fillRule: "evenodd",
    d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
  }));
};

var Cross = (0, _styledComponents.default)(CrossSvg).withConfig({
  displayName: "Cross",
  componentId: "sc-x7byax-0"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
Cross.defaultProps = {
  color: "" + colors.norwester,
  height: 14,
  width: 14
};
var _default = Cross;
exports.default = _default;